<template>
  <div class="limiter">
    <!-- <div class="container-login">
      <div class="wrap-login">
        <div class="login-form loginlayout ">
          <span class="login-form-title pb-5">
            Account Login
          </span>
          <v-row class="mb-3" v-show="messages.length > 0">
            <v-col cols="12">
           
            </v-col>
          </v-row>
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="12" class="pb-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.username"
                    class="input100"
                    placeholder="Username"
                    :error-messages="errors"
                    outlined
                    hide-details="auto"
                    append-icon="mdi-account"
                      v-on:keydown.enter="login()"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <v-text-field
                    v-model="form.password"
                    class="input100"
                    placeholder="Password"
                    :error-messages="errors"
                    outlined
                    hide-details="auto"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="() => (show1 = !show1)"
                    v-on:keydown.enter="login()"
                  ></v-text-field>
              
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
         
      
        </div>
        <div class="login-more"></div>
      </div>
    </div> -->
    <div class="main-wrapper login-body">
      <div class="login-wrapper">
        <div class="container">
          <div class="loginbox">
            <div class="login-left">
              <img class="img-fluid" src="@/assets/Gananms.png" alt="Logo" />
            </div>
            <div class="vl"></div>
            <div class="login-right">
              <div class="login-right-wrap">
                <h1>Login</h1>
                <p class="account-subtitle">Access to our dashboard</p>
                <div v-for="(msg, index) in messages" :key="index">
                  <v-alert
                    dense
                    class="pl-3"
                    type="error"
                    text
                    color="red"
                    border="left"
                    colored-border
                  >
                    {{ msg }}
                  </v-alert>
                </div>
                <!-- Form -->
                <form>
                  <ValidationObserver ref="observer">
                    <v-row>
                      <v-col cols="12" class="pb-2">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Username"
                          rules="required"
                        >
                          <v-text-field
                            v-model="form.username"
                            class="input100"
                            placeholder="Username"
                            :error-messages="errors"
                            outlined
                            hide-details="auto"
                            append-icon="mdi-account"
                            v-on:keydown.enter="login()"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Password"
                          rules="required"
                        >
                          <v-text-field
                            v-model="form.password"
                            class="input100"
                            placeholder="Password"
                            :error-messages="errors"
                            outlined
                            hide-details="auto"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="() => (show1 = !show1)"
                            v-on:keydown.enter="login()"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                  <v-btn
                    dark
                    class="login-form-btn"
                    @click.stop="login()"
                    :loading="loading"
                  >
                    Sign in
                  </v-btn>
                </form>
                <!-- /Form -->
                <div class="text-center pt-8 pb-2 ma-auto">
                  <router-link to="/forgot-password" class="txt1">
                    Forgot password?
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, max } from "vee-validate/dist/rules";
import VuelidateMixin from "@/mixins/VuelidateMixins";
import { Login } from "../../../models/EntityModels/Login";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} is required",
});
extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});
extend("email", {
  ...email,
  message: "Email must be valid",
});
export default {
  name: "Login",
  props: {
    source: String,
  },
  components: {
    // BaseInput
  },
  data() {
    return {
      form: new Login(),
      value: String,
      messages: [],
      errors: [],
      show1: false,
      loading: false,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  name: "Login",
  mixins: [VuelidateMixin],
  methods: {
    async login() {
      const isValid = await this.$refs.observer.validate();
      // console.log("Validation is", isValid);
      if (isValid) {
        this.loading = true;
        this.$store
          .dispatch("user/Login", {
            username: this.form.username,
            password: this.form.password,
          })
          .then(async (res) => {
            this.messages = null;
            if (res.data && res.data.accessToken) {
              // Save token first so it is available for subsequent requests
              localStorage.setItem("token", res.data.accessToken);
              localStorage.setItem("user", JSON.stringify(res.data));

              // Now fetch user details and permissions
              try {
                console.log("DEBUG: Dispatching user/LoginUser");
                await this.$store.dispatch("user/LoginUser");
                console.log("DEBUG: user/LoginUser Dispatched Successfully");
              } catch (error) {
                console.error("Failed to fetch user details", error);
              }

              try {
                await this.$router.replace({ name: "DashboardHome" });
              } catch (navErr) {
                await this.$router.replace({ path: "/" });
              }

              this.$store
                .dispatch("GetPaginationSettings")
                .catch(() => {});
              this.$store.dispatch("GetPOSSettings").catch(() => {});
              this.$store
                .dispatch("sitesetting/SiteSettingView", 1)
                .catch(() => {});

              this.loading = false;
            } else if (res.data.redirectLink == "change-password") {
              var userName = this.CryptoJS.AES.encrypt(
                this.form.username,
                "changepassword"
              ).toString();
              var password = this.CryptoJS.AES.encrypt(
                this.form.password,
                "changepassword"
              ).toString();
              this.$router.push({
                path: `/change-password`,
                query: {
                  us: userName,
                  pwd: password,
                },
              });
              this.loading = false;
            } else {
              this.loading = false;
              this.$toast.error(res.title);
            }
          })
          .catch((err) => {
            this.messages = [];
            this.loading = false;
            // this.messages.push(err.data);
            if (err && err.data && err.data.message) {
                 this.messages.push(err.data.message);
            } else if (err && err.data && typeof err.data === 'string') {
                 this.messages.push(err.data);
            } else {
                 this.messages.push("Incorrect username or password.");
            }

            this.form.username = "";
            this.form.password = "";

            this.$refs.observer.reset();
          });
      }
      //
    },
    forgotPassword() {
      this.$router.push("/forgot-password");
    },
  },
};
</script>
<style scoped>
.login-body {
  display: table;
  height: 100vh;
  min-height: 100vh;
}
.main-wrapper {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}
body {
  background-color: #f8f9fa;
  color: #333;
  font-family: "Mada", sans-serif;
  font-size: 1rem;
  height: 100%;
  line-height: 1.5;
  overflow-x: hidden;
}
.login-wrapper {
  width: 100%;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}
@media (min-width: 1200px) .container {
  max-width: 1140px;
}
@media (min-width: 992px) .container {
  max-width: 960px;
}
@media (min-width: 768px) .container {
  max-width: 720px;
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.txt1 {
  font-family: Poppins;
  font-size: 13px;
  line-height: 1.4;
  color: #464646 !important;
  text-decoration: none;
}
.login-wrapper .loginbox {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  margin: 1.875rem auto;
  max-width: 800px;
  min-height: 500px;
  width: 100%;
}
.login-wrapper .loginbox .login-left {
  align-items: center;
  background: linear-gradient(180deg, #ffffff, #ffffff);
  border-radius: 6px 0 0 6px;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  display: flex;
}
.img-fluid {
  width: 100%;
  height: 100%;
  border-radius: 6px 0 0 6px;
}
img {
  vertical-align: middle;
  border-style: none;
}
.login-wrapper .loginbox .login-right {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 40px;

  width: 400px;
}
.login-wrapper .loginbox .login-right .login-right-wrap {
  max-width: 100%;
  flex: 0 0 100%;
}
.account-subtitle {
  color: #4c4c4c;
  font-size: 17px;
  margin-bottom: 1.875rem;
  text-align: center;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.form-group {
  margin-bottom: 1.25rem;
}
.form-group {
  margin-bottom: 1rem;
}
form {
  display: block;
  margin-top: 0em;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.form-control {
  border: 1px solid #ddd;
  box-shadow: none;
  color: #333;
  font-size: 15px;
  height: 40px;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.text-center {
  text-align: center !important;
}
input {
  outline: none;
}
.container-login-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 576px) {
  .login-form {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 150px;
  }
  .rs1-wrap-input100,
  .rs2-wrap-input100 {
    width: 100%;
  }
  .rs2-wrap-input100 {
    border-left: 1px solid #e6e6e6;
  }
}
.wrap-input100 {
  width: 100%;
  position: relative;
  border: 1px solid #e6e6e6;
}
.rs1-wrap-input100,
.rs2-wrap-input100 {
  width: 50%;
}
.rs2-wrap-input100 {
  border-left: none;
}
.input100 {
  display: block;
  width: 100%;
  background: transparent;
  font-family: Poppins;
  font-size: 18px;
  color: #666666;
  line-height: 1.2;
  padding: 0 25px;
}
.login-form input.input100 {
  height: 40px;
}
.login-wrapper .loginbox .login-right h1 {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 5px;
  text-align: center;
}
.vl {
  border-left: 1px solid rgb(201, 206, 201);
  height: 500px;
}
.login-form-btn {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  width: 60%;
  align-content: center;
  height: 50px;
  margin-left: 20%;
  border-radius: 60px;
  background-color: #512d82 !important;
  margin-top: 15px;
  font-family: poppins;
  font-size: 13px;
  font-weight: 600;
  color: #fff !important;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 1px;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}
.login-form-btn:hover {
  background-color: #3d2263 !important;
  cursor: pointer;
}
[type="submit"]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}
.btn-primary {
  background-color: #00d0f1;
  border: 1px solid #00d0f1;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
